export class DepositModel {
  accountId: string = '';
  paymentOptions : string[] = ['PIX'];
  person : DepositPersonModel = new DepositPersonModel();
  value: number = 0;
  dueDate: Date = new Date()
  origin: string = 'PIX'
}

export class DepositPersonModel
{
  cpf: string = '';
  name: string = '';
}
